import request from '@/src/utils/request'

//取得寵物旅館設定（payload 可含 adminBackfill：補登歷史訂單）
export const getHotelBookings = async (productId, payload) => {
  const params = { ...payload }
  if (params.adminBackfill) {
    params.adminBackfill = 1
  }
  const response = await request.get(`/admin/hotel/${productId}/bookings`, {
    params,
  })
  return response
}
